module.exports = __webpack_public_path__ + "img/icon_filter.5be9eba5.svg";